import { render } from "./DocumentIcon16.vue.js?vue&type=template&id=2c30f3bd!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./DocumentIcon16.vue?vue&type=template&id=2c30f3bd"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__